import { DataTable, DEFAULT_TABLE_HEIGHT } from 'components/DataTable'
import { HomeSectionHeader } from 'components/Header/HomeSectionHeader'
import { StyledHomeSection } from 'components/Header/HomeSectionHeader.styled'
import Collapse from 'components/Collapse'
import { StyledMyActivitySection } from './MyActivityYTD.styled'
import { Loader } from 'components/Loader'
import { useEffect, useState } from 'react'
import { useExpand } from 'hooks/useExpand'
import { MY_ACTIVITY_YTD } from 'common/constants'
import { IDashboardVehicles } from 'types/vehicleTypes'
import { useDashboardStore } from 'store/useDashboardStore'
import shallow from 'zustand/shallow'

interface IMyActivity {
  loading: boolean
}

export const MyActivityYTD = ({ loading }: IMyActivity) => {
  const [myActivityData, setMyActivityData] = useState([])
  const { groundingData } = useDashboardStore((state) => state, shallow)
  const { state: expandState, action: expandAction } = useExpand({ componentOpen: true } as never)

  const { componentOpen } = expandState
  const { setExpand } = expandAction

  useEffect(() => {
    if (groundingData) {
      let groundedList = { name: MY_ACTIVITY_YTD.GROUNDED }
      let purchasedGroup = { name: MY_ACTIVITY_YTD.GROUNDED_PURCHASED }
      let auctionGroup = { name: MY_ACTIVITY_YTD.WEB_AUCTION_PURCHASED }

      groundingData?.ytd?.forEach((item) => {
        groundedList = { ...groundedList, [item.month]: item.grounded }
        purchasedGroup = { ...purchasedGroup, [item.month]: item.purchased }
        auctionGroup = { ...auctionGroup, [item.month]: item.auctionPurchased }
      })
      setMyActivityData([groundedList, purchasedGroup, auctionGroup])
    }
  }, [groundingData])

  return (
    <StyledHomeSection>
      <HomeSectionHeader
        sectionTitle="My Activity YTD"
        onClick={() => {
          setExpand(!componentOpen)
        }}
        isExpand={componentOpen}
      />
      <Collapse in={componentOpen}>
        <StyledMyActivitySection>
          {loading && <Loader overlay />}
          {!loading && (
            <DataTable
              height={DEFAULT_TABLE_HEIGHT}
              columns={[
                {
                  id: 'month',
                  Header: 'Month',
                  Cell: ({ cell }) => {
                    return <span>{cell?.row?.original.name}</span>
                  }
                },
                ...groundingData?.ytd.map((item) => {
                  return {
                    Header: item.month,
                    Cell: ({ cell }) => {
                      return <span>{cell?.row?.original[item.month]}</span>
                    }
                  }
                })
              ]}
              data={myActivityData}
            ></DataTable>
          )}
        </StyledMyActivitySection>
      </Collapse>
    </StyledHomeSection>
  )
}
